import { Key as BaseKey } from '@lightningjs/ui';
import { Utils } from '@lightningjs/sdk';

export class IconKey extends BaseKey {
  set icon(src) {
    this._icon = src;
    //call for _update
    this._update();
  }

  get icon() {
    return this._icon;
  }

  _update() {
    if (!this.active) {
      //blocking update if not active.
      return;
    }
    const hasFocus = this.hasFocus();
    let { focused, unfocused = 0xff000000 } = this.backgroundColors;
    //Use labelColors and label to color the icon.
    let { focused: labelFocused, unfocused: labelUnfocused = 0xffffffff } = this.labelColors;
    this.patch({
      Background: { color: hasFocus && focused ? focused : unfocused },
      Label: {
        src: Utils.asset(this.icon),
        color: hasFocus && labelFocused ? labelFocused : labelUnfocused,
      },
    });
  }
}
